import request from '../Functions/ajax/request'



export default async function PropertiesLoader ({ params })
{
	return { page: getPage({ params }) };
}

async function getPage ({ params })
{
	try
	{
		var properties = await request('/property/list')
		.config({ })
		.post();
	}
	catch (e)
	{
		console.error(e);
	}

	return { properties };
}